/* Belgravia Wear — tiny progressive-enhancement layer.
   Reveals .bw-reveal elements on scroll. Nothing here is load-bearing. */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.bw-reveal').forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function scan() { document.querySelectorAll('.bw-reveal:not(.is-in)').forEach(function (el) { io.observe(el); }); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
